export default "__VITE_ASSET__CSCPD6TH__"